<template>
  <div>
    <InfoDetails :data="newsDetail" :isTranslated="isTranslated">
      <template v-slot:overview>
        <!-- AI -->
        <div class="overview" v-if="!!overview">
          <AIOverview
            :overviewTitle="overviewTitle"
            @onShowOverview="onShowOverview"
            :isTranslated="isTranslated"
            defaultShowedOverview
          >
            <template v-slot:content>
              <div style="white-space: pre-line">{{ overview }}</div>
            </template>
          </AIOverview>
        </div>
      </template>
      <template v-slot:time>
        <InfoTime :data="newsDetail" :props="{ time: 'pubDate' }" />
      </template>
    </InfoDetails>
    <Disclaimer />
  </div>
</template>

<script>
import InfoDetails from '@/components/common/info/InfoDetails.vue'
import InfoTime from '@/components/common/info/InfoTime.vue'
import FileEntry from '@/components/common/info/FileEntry.vue'
import Disclaimer from '@/components/common/Disclaimer.vue'
import AIOverview from '@/components/common/AIOverview.vue'
import { showMsg, watchMsg, sendMsg } from '@/plugins/msg'

import { regStyle } from '@/utils/constant'
export default {
  components: { InfoDetails, InfoTime, FileEntry, Disclaimer, AIOverview },
  data() {
    return {
      // overviewTitle: '我是融脉AI智投，可以总结文章信息。',
      newsDetail: {},
      isTranslated: this.$route.query.isTranslated === 'true'
    }
  },
  computed: {
    id() {
      return +this.$route.query.id
    },
    overviewTitle() {
      return `${this.$t('总结完成，以下是我提取的核心信息')}`
    },
    overview() {
      if (this.$route.query.hiddenAI) {
        return ''
      }

      return this.isTranslated ? this.newsDetail.translatedOverview : this.newsDetail.overview
    }
  },
  created() {
    this.getNewsDetail(this.id)
  },
  mounted() {
    watchMsg(this.watchCallback)
  },
  methods: {
    watchCallback(res) {
      if (res.event === 'newsDetailTranslate') {
        this.isTranslated = !this.isTranslated
      }
    },
    async getNewsDetail(id) {
      const res = await this.$post(this.$api.news + '/v2/info', { id })
      // 本地联调
      // const res = await this.$post('http://192.168.3.132:7300/news/v2/info', { id })
      const data = res.body ?? {}

      // 发送 原文语言 给父级窗口，用来判断是否显示翻译按钮
      sendMsg({
        event: 'detailLang',
        lang: data.lang
      })

      const content = data.content?.replace(regStyle, '') ?? ''
      const translatedContent = data.translatedContent?.replace(regStyle, '') ?? content
      const translatedTitle = data.translatedTitle ?? data.title
      this.newsDetail = {
        ...data,
        content,
        translatedContent,
        translatedTitle
      }
    },
    onShowOverview() {
      const aiName = this.$route.query.aiName ?? this.$t('融脉AI智投')

      this.overviewTitle = `${aiName}${this.$t('已提取核心信息')}`
    },

    handleClickDisclaimer() {
      showMsg('newsDetail')
    }
  }
}
</script>
<style lang="scss">
.overview {
  margin-top: 15px;
}
.article-content {
  table {
    width: 100%;
    margin-top: 10px;
    text-align: center;
    word-break: break-all;
    font-size: 24px;
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  th,
  td {
    border-width: 1px;
    border-style: solid;
    padding: 10px;
  }
  img {
    max-width: 100%;
  }
}
</style>
